/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import { withRouter } from 'react-router-dom'

// lib
import bindStateToProps from 'lib/bindStateToProps'
import bindActionCreators from 'lib/bindActionCreators'
import isEqualProps from 'lib/isEqualProps'
import mapActionLog from 'lib/mapActionLog'
import config from 'config'
import dizzyRobot from 'static/image/dizzy_robot.png'

// redux modules (action)
// import { actions as formActions } from 'store/modules/form'

// react components
// import PurplebookForeignForm from 'components/organisms/PurplebookForeignForm'

import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LogoImg from 'static/image/logo.png'
import CoolsmsLogoImg from 'static/image/coolsms.png'
import Grid from '@material-ui/core/Grid'

class PortalContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    mapActionLog(this)
    this.state = {
      desc: {
        '/addressbook': { title: '메시지 보내기', path: '/purplebook' },
        '/addressbook2': { title: '메시지 보내기', path: '/purplebook' },
        '/frontpage': { title: '메인페이지', path: '/' },
        '/index.php': { title: '메인페이지', path: '/' },
        '/report': { title: '메시지 전송 내역', path: '/message-log/detail' },
        '/aboutalimtalk': {
          title: '알림톡이란?',
          path: config.supportPageHost + '/hc/ko/articles/115008026607',
          newTab: true
        },
        '/java_sdk_start_here': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/rest_api': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/sms_api_v2': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/java_sdk_example_message': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/referral_code': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/sdk_java_getting_started_ko': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/developer': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/java_sdk_example': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/python_sdk_start_here': {
          title: '개발자문서',
          path: 'https://developer.coolsms.co.kr/',
          newTab: true
        },
        '/app_intro': {
          title: '앱 목록',
          path: '/apps'
        },
        '/app_list': {
          title: '앱 목록',
          path: '/apps'
        },
        '/kakao': {
          title: '카카오 알림톡',
          path: '/kakao/templates'
        }
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    return !isEqualProps(nextProps, this.props)
  }

  onClickPortalLink() {}

  render() {
    const {
      classes,
      errorTitle = 'Oops..!',
      errorDescription = '존재하지 않거나 접근 권한이 없는 페이지 입니다.'
    } = this.props
    const { desc = {} } = this.state
    const current = desc[window.location.pathname.toLowerCase()]
    const { title, path, newTab = false } = current || {}
    if (!path) {
      return (
        <div>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            className={classes.errorWrap}
          >
            <Grid item xs={12}>
              <div className={classes.errorTitle}>
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    fontSize: '0.6em',
                    color: 'rgb(0 0 0 / 29%)'
                  }}
                >
                  Icons made by{' '}
                  <a
                    href="https://www.flaticon.com/authors/flat-icons"
                    title="플랫 아이콘"
                    style={{ color: 'inherit' }}
                  >
                    플랫 아이콘
                  </a>{' '}
                  from{' '}
                  <a
                    href="https://www.flaticon.com/"
                    title="Flaticon"
                    style={{ color: 'inherit' }}
                  >
                    www.flaticon.com
                  </a>
                </div>
                <Grid
                  container
                  alignItems="flex-end"
                  justifyContent="center"
                  spacing={3}
                >
                  <Grid item xs={12}>
                    <img
                      src={dizzyRobot}
                      alt="icon"
                      title="icon"
                      style={{
                        maxWidth: '100%',
                        width: 128
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h3" color="textSecondary">
                      <strong>{errorTitle}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </div>
              <Typography gutterButtom>{errorDescription}</Typography>
              <div className={classes.btnArea}>
                <a
                  href={config.homePath}
                  title="홈페이지"
                  className={classes.link}
                >
                  <Button color="primary">홈페이지</Button>
                </a>
                <a
                  href="/dashboard"
                  title="관리콘솔 메인"
                  className={classes.link}
                >
                  <Button color="primary">관리콘솔</Button>
                </a>
                <a
                  href={config.supportPageHost}
                  title="지원센터 바로가기"
                  className={classes.link}
                >
                  <Button color="primary">지원센터</Button>
                </a>
                <Button
                  color="primary"
                  onClick={() => {
                    window.history.back()
                  }}
                >
                  뒤로가기
                </Button>
              </div>
              <div className={classes.logoWrap}>
                <a href={config.homePath} title="홈페이지로 돌아가기">
                  <img
                    className={classes.logoImg}
                    src={config.isCoolsms ? CoolsmsLogoImg : LogoImg}
                    alt="logo"
                    title="logo"
                  />
                </a>
              </div>
            </Grid>
          </Grid>
        </div>
      )
    }
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              현재 찾고 계신 페이지는 새로운 주소로 이동되었습니다.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" align="center">
              <strong>{title}</strong> 페이지를 찾고계신가요?{' '}
              {newTab === true ? (
                <a
                  href={path}
                  title={title}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => this.onClickPortalLink}
                >
                  이곳을 클릭해 이동하세요.
                </a>
              ) : (
                <a
                  href={path}
                  title={title}
                  onClick={e => this.onClickPortalLink}
                >
                  이곳을 클릭해 이동하세요.
                </a>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" align="center">
              {window.location.pathname} {'->'} {path}
            </Typography>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withRouter(
  connect(bindStateToProps({}), bindActionCreators({}))(PortalContainer)
)
